import { ClientForm } from './components';

const CreateEditClient = () => {
    return <ClientForm />;
};

export default CreateEditClient;

